(function ($) {

    var timeLines = $(".partner-timeline");
    if (timeLines.length === 0) return; // Do nothing, when there is no time line's

    $.each(timeLines, function () {

        var $timeLine = $(this);
        var $stepButtons = $timeLine.find(".partner-timeline__navigation__circlebtn button");
        var $timeLineSteps = $timeLine.find(".partner-timeline__step");
        var $stepMobileButtons = $timeLine.find(".partner-timeline__navigation__mobilebtnTitle button");
        var $stepMobileContents = $timeLine.find(".partner-timeline__navigation__mobilebtnTitle div");

        // Make navigation work
        $stepButtons.click(function(e) {
            e.preventDefault();

            var stepGuid = $(this).data("step-guid");

            $stepButtons.removeClass('active');
            $(this).addClass('active');

            $timeLineSteps.removeClass('active');
            $timeLine.find(".partner-timeline__step[data-guid=\"" + stepGuid + "\"]").addClass('active');

        });

        $stepMobileButtons.click(function (e) {
            e.preventDefault();

            var stepGuid = $(this).data("step-guid");

            $stepMobileButtons.removeClass('active');
            $(this).addClass('active');

            $stepMobileContents.removeClass('active');
            $timeLine.find(".partner-timeline__navigation__mobilebtnTitle div[data-guid=\"" + stepGuid + "\"]").addClass('active');

        });


        // Previous button
        $timeLine.find('.partner-timeline__steps__nav-btn__previous').click(function (e) {
            e.preventDefault();

            $timeLine.find('.partner-timeline__navigation__circlebtn button.active').removeClass('active').prev('.partner-timeline__navigation__circlebtn button').addClass('active');
            $timeLine.find('.partner-timeline__step.active').removeClass('active').prev('.partner-timeline__step').addClass('active');

            showHidePrevNextButtons();
        });

        // Next button
        $timeLine.find('.partner-timeline__steps__nav-btn__next').click(function (e) {
            e.preventDefault();

            $timeLine.find('.partner-timeline__navigation__circlebtn button.active').removeClass('active').next('.partner-timeline__navigation__circlebtn button').addClass('active');
            $timeLine.find('.partner-timeline__step.active').removeClass('active').next('.partner-timeline__step').addClass('active');

            showHidePrevNextButtons();
        });

        var showHidePrevNextButtons = function () {
            $('.partner-timeline__steps__nav-btn button').hide();

            var prev = $timeLine.find('.partner-timeline__step.active').prev('.partner-timeline__step');
            if (prev.length > 0) {
                $timeLine.find('.partner-timeline__steps__nav-btn__previous').show();
            }

            var next = $timeLine.find('.partner-timeline__step.active').next('.partner-timeline__step');
            if (next.length > 0) {
                $timeLine.find('.partner-timeline__steps__nav-btn__next').show();
            }
            
        }
        showHidePrevNextButtons();

    });

})(jQuery);